import { throwError as observableThrowError, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ModulosConfigService {
  private apiUrl = environment.apiUrl;
  private estruturaUrl = `${this.apiUrl}public/estrutura/`;

  constructor(private _http: HttpClient) {
  }

  getEstruturaSistema(empresaId): Observable<{}> {
    return this._http.get('assets/data/modulos-gestao-estrutura.json')
      .pipe(map(data => {
        return data;
      }));
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
